import { Box, Button, Checkbox, Grid, Icon, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { max } from 'date-fns';
import React, { Fragment, useEffect, useState } from 'react';
import EntityListItem from './EntityListItem';
import {
  getHashtags,
  getHashtagData,
  removeHashtags,
  infoList,
} from '@/lib/utils/DataFormat';
import axios from 'axios';

const useStyles = (theme) => ({
  cardDescription: {
    maxHeight: '70px !important',
    overflowY: 'auto !important',
  },
  container: {
    justifyContent: 'center !important',
  },
  tag: {
    fontWeight: 'bolder !important',
    paddingRight: '4px !important',
  },
  checkbox: {
    padding: '1px !important',
  },
  btnStyle: {
    color: 'rgba(0, 0, 0, 0.87) !important',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)  !important',
    },
  },
});

export const EntityCard = React.memo(
  ({
    minGridWith = 3,
    entity,
    showParticipants,
    nrHosts,
    refreshEntityList,
  }) => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [edit, setEdit] = useState(false);
    const [checked, setChecked] = useState([]);
    const [visitors, setVisitors] = useState(entity.visitors || []);

    const toggleCheckInRoom = (entityVisitorId) => {
      if (checked.includes(entityVisitorId)) {
        setChecked(checked.filter((c) => c !== entityVisitorId));
      } else {
        setChecked([...checked, entityVisitorId]);
      }
    };
    const tags = getHashtags(entity.description_short).map((tag) =>
      getHashtagData(tag)
    );

    useEffect(() => {
      setVisitors(entity.visitors || []);
      setChecked([]);
    }, [nrHosts]);

    const deleteHosts = () => {
      axios
        .put(`/api/visitor/entities/${entity.id}/unconnectvisitors`, {
          ids: checked,
        })
        .then(() => {
          setVisitors(
            visitors.filter((v) => !checked.includes(v.entityVisitors.id))
          );
          refreshEntityList();
          setChecked([]);
          setEdit(false);
        });
    };

    return (
      <Fragment>
        <Grid
          item
          size={{
            xs: 12,
            sm: showParticipants ? 6 : Math.max(6, minGridWith),
            md: showParticipants ? 6 : Math.max(4, minGridWith),
            lg: showParticipants ? 6 : Math.max(3, minGridWith),
          }}
        >
          <EntityListItem url={`/live/item/${entity.id}`} entity={entity} />
          <Box p={1} align="left">
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
              sx={classes.cardDescription}
            >
              {tags.map((tagData) => (
                <Box
                  component="span"
                  sx={classes.tag}
                  key={tagData.tag}
                  style={{
                    ...(tagData.color ? { color: `#${tagData.color}` } : {}),
                  }}
                >
                  {tagData.title}
                </Box>
              ))}
              {tags.length > 0 && <br />}
              {removeHashtags(entity.description_short)}
            </Typography>
          </Box>
        </Grid>
        {showParticipants && (
          <Grid item size={{ xs: 12, sm: 6 }}>
            <Box textAlign="left">
              {visitors.length > 0 && (
                <Box display="flex">
                  {edit && (
                    <Box flexGrow={1}>
                      <Button
                        startIcon={<Icon>delete</Icon>}
                        size="small"
                        onClick={deleteHosts}
                        disabled={checked.length === 0}
                        color="secondary"
                      >
                        delete ({checked.length})
                      </Button>
                    </Box>
                  )}
                  <Box>
                    <Button
                      startIcon={<Icon>edit</Icon>}
                      size="small"
                      onClick={() => setEdit(!edit)}
                      sx={classes.btnStyle}
                    >
                      {edit ? 'Stop edit' : 'Edit'}
                    </Button>
                  </Box>
                </Box>
              )}

              {visitors.map((v) => (
                <Box key={v.entityVisitors.id} display="flex">
                  <Box>
                    {/* {edit && (
                        <input
                        className={}
                          type="checkbox"
                          //   name={`check_${entity.id}_${v.id}`}
                          checked={checked.includes(v.entityVisitors.id)}
                          onClick={() => toggleCheckInRoom(v.entityVisitors.id)}
                        />
                      )} */}

                    {edit && (
                      <Checkbox
                        sx={classes.checkbox}
                        size="small"
                        checked={checked.includes(v.entityVisitors.id)}
                        onClick={() => toggleCheckInRoom(v.entityVisitors.id)}
                      />
                    )}
                  </Box>
                  <Box>
                    <strong>{v.full_name}</strong>
                    <br />
                    {infoList([v.title, v.company, v.location_city])}
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
        )}
      </Fragment>
    );
  },
  (prevProps, nextProps) =>
    prevProps.nrHosts === nextProps.nrHosts &&
    prevProps.showParticipants === nextProps.showParticipants
);
EntityCard.displayName = 'EntityCard';
